<template>
  <div class="chat-wrapper" style="background: white; padding: 20px; position: relative">
    <!-- <pre>
      {{ JSON.stringify(currentChat, null, 3) }}
    </pre> -->
    <!-- RIGHT COLUMN -->
    <div
      class="chat__bg"
      :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeChatUser === null,
      }"
    >
      <template v-if="activeChatUser">
        <VuePerfectScrollbar
          class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
          style=""
          :settings="settings"
          ref="chatLogPS"
        >
          <div class="chat__log" ref="chatLog" style="">
            <AIChatLog
              :userId="activeChatUser.id"
              v-if="activeChatUser"
              :CurrentUser="activeChatUser"
              :ChatMessages="currentChat.Chat"
              :OtherIsTyping="waitingOtherSide"
              @RaiseCta="OnInterviewCta"
            ></AIChatLog>
          </div>
        </VuePerfectScrollbar>
        <div class="chat__input">
          <vs-textarea
            style="background: white; width: 100%; padding-right: 50px; height: 45px"
            placeholder="Shift + Enter - new line, Enter - send"
            class="chat-msg-textarea"
            v-model="typedMessage"
            @keyup.enter="sendMsg"
            rows="1"
          />
          <vs-button
            class="bg-primary-gradient ml-4"
            style="position: absolute; right: 0px; top: 0px"
            type="filled"
            @click="sendMsg"
          >
            <FeatherIcon
              icon="SendIcon"
              style="width: 13px; vertical-align: bottom"
            ></FeatherIcon>
          </vs-button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import OpenAIClient from "@/openai/OpenAIClient.js";
import AIChatLog from "@/views/components/chat/AIChatLog.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AIChatNavbar from "@/views/components/chat/AIChatNavbar.vue";
import SkillsService from "@/skills/skillsService.js";
import FeatherIcon from "@/components/FeatherIcon.vue";
import accountsService from "../../accounts/accountsService";

export default {
  created() {},
  async mounted() {
    // Load current user

    var user = accountsService.getUserFromLocalStorage();

    this.activeChatUser = {
      id: user.User.Id,
      name: user.User.FirstName,
      img: user.User.UserImageUrl,
      status: "Online",
      tags: user.User.Tags,
    };

    if (
      this.autoStart &&
      (!this.ChatToLoad || !this.ChatToLoad.Chat || this.ChatToLoad.Chat.length == 0)
    ) {
      var allMyTasks = [
        {
          task: "Edited services on the demo server.",
          type: "Content editing",
        },
        {
          task: "Changed the audit trail config on the demo server.",
          type: "Administrative",
        },
        {
          task: "Created a content page on the demo server.",
          type: "Conten editing",
        },
        {
          task: "Pushed code that changes the audit trail.",
          type: "Development",
        },
      ];

      var positions = user.Positions.map(function (itm) {
        return {
          title: itm.title,
          description: itm.Description,
        };
      });

      var myTasksResult = await SkillsService.getContentEdit('"' + user.User.Email + '"');

      var myTimesheeetsResult = await SkillsService.getTimeSheets(
        '"' + user.User.Email + '"'
      );

      var finalTasksInfo = [];
      if (this.context) {
        this.currentChat.Chat.push({
          role: this.context && this.context.role ? this.context.role : "user",
          time: new Date(),
          isSent: true,
          isSeen: true,
          HideFromUI:
            this.context && this.context.HideFromUI ? this.context.HideFromUI : true,
          content: this.context.content,
        });
      } else {
        this.currentChat.Chat.push({
          role: "user",
          time: new Date(),
          isSent: true,
          isSeen: true,
          HideFromUI: true,
          content: `
            - DO NOT JUSTIFY YOURSELF! DO NOT REPEAT USER\n
            - Only reply with nicely formatted RAW HTML, NO MARKDOWN!, no plain text.\n
            - DO NOT JUSTIFY YOURSELF!\n
            - Allowed tags: H3, H4, H5, P, BR, A, IMG, UL, LI, TCVCard. Nothing else.\n
            - User name is ${user.User.FirstName} ${
            user.User.LastName
          } greet the user and ask if he's ready to help out by providing some feedback. Once there is a response - proceed.\n
            - You will be given the activities.\n
            - Activities that fall within 2 seconds bracket are one activity.
            - Summarize actions for same items, for example You created a news item, then you edited. You created a user with profile, then you edit it. Etc. Use the title of the item for clarity.\n
            - Ask me about feedback on any of the tasks in a very friendly tone, again ensuring me that the feedback may help many other people and me.\n
            - Do not list all activities at once. Go one by one and everytime the user confirms there is no more feedback - encourage him and say there are x more items but if they are tired - it's still appreciated.
            - Once the interview is over - output the result like this: ONLY THIS ELEMENT FILLING THE JSON PROPERLY DO NOT OUTPUT ANYTHING ELSE:<TCVCard>{ "title":"User name here - feedback for date here", "content": "HTML FORMATTED STRING OF THE FEEDBACK REPORT. 1 SECTION FOR THE FEEDBACK GIVEN (ADD RESPONSIBLE TEAM TO EACH ITEM AS FOLLOWS: dev@eveliko.com for developers, devops@eveliko.com for administrative, onboarding@eveliko.com for documentation and onboarding and management@eveliko.com for management or unclear). TRY TO PROVIDE OVERVIEW OF EACH ITEM (WHAT THE USER NEEDS). ONE FOR ALL ACTIVITIES I PERFORMED (INCLUDING ALL DATA YOU HAVE). TIMESTAMPS SHOULD BE FORMATTED AS YYYY MM DD HH:mm", "ctas": ["Share with", "Save"] }</TCVCARD>
              \n\n Activities (Do not list them at once unless asked):${JSON.stringify(
                myTasksResult
              )}.
            - DO NOT JUSTIFY YOURSELF! DO NOT REPEAT USER. IF THERE ARE NO TASKS - STATE IT AND ASK IF THERE IS ANY OTHER FEEDBACK.\n
            - Activities that fall within 2 seconds bracket are one activity.
            - Summarize actions for same items, for example You created a news item, then you edited. You created a user with profile, then you edit it. Etc. Use the title of the item for clarity.            `, //`I will give you a list of activities I performed on our servers today. Group some activities that happened in a 2-3 seconds range as a single task. Do not ask the user if they are the same. For example user item + profile item activity is likely a user creation. A couple of items in the same second is likely item creation and publish / save, etc. DO NOT LIST THEM ALL!!! ASK ME FOR FEEDBACK ONE BY ONE, THEN PRESENT HTML REPORT. LIST TITLE, TYPE AND ACTION. HERE IS THE LIST: ${JSON.stringify(myTasksResult)}.\n\n help me build a feedback report by asking question for each item ONE BY ONE!!!. You always use UL + LI for listing things. Use strong and p tags to make things stand out. Like titles, etc. Avoid showing long timestamps, user friendly date format and also - avoid showing IDs, unless asked. Once I say that I am ready or we gone through all tasks, provide report in the following format: <TCVCard>{ "title":"Feedbakck report", "content": "The HTML RAW generated report in the following structure: The feedback then a section of the activities and the date.", "ctas": ["Share with", "Save"] }`
        });
      }

      this.resendChat();
    }
  },
  data() {
    return {
      activeChatUser: null,
      clickNotClose: false,
      settings: {
        maxScrollbarLength: 40,
        wheelSpeed: 0.4,
      },
      isChatSidebarActive: false,
      isChatPinned: false,
      userProfileId: null,
      activeProfileSidebar: false,
      waitingOtherSide: false,
      isActiveUser: true,
      currentChat: {
        Identifier: "",
        Chat: [],
        temperature: 1,
        MetaType: "AIInterview"
      },
      typedMessage: "",
      SkillsWithBreadCrumbs: null,
    };
  },
  methods: {
    resendChat() {
      var instance = this;
      instance.waitingOtherSide = true;
      OpenAIClient.chatRaw(this.currentChat).then(function (response) {
        var currentUserChats = response.data;
        instance.$set(
          instance.currentChat,
          "Chat",
          currentUserChats.map(function (chat) {
            return {
              ...chat,
              time: new Date(),
              isSent: chat.role == "user",
            };
          })
        );

        instance.$emit("ChatUpdated");
        //instance.waitingOtherSide = false;
      });
    },
    OnInterviewCta(cta, data) {
      if (this.IsDefaultUserInterview) {
        if (cta == "Requirements Skill Gap") {
          var instance = this;

          if (!this.SkillsWithBreadCrumbs) {
            SkillsService.GetSkillWithBreadCrumbs().then(function (response) {
              instance.$set(instance, "SkillsWithBreadCrumbs", response.data);
              window.SkillsWithBreadCrumbs = response.data;

              instance.currentChat.Chat.push({
                time: new Date(),
                isSent: true,
                role: "system",
                content:
                  'Ask the user to give you the list with the requirements in any format. Once you have it, make sure to make it formatted as JSON in this way: [{requirement: "Requirement"}] and return it as a response.',
                // JSON.stringify(window.SkillsWithBreadCrumbs.Skills),
                isSeen: true,
                HideFromUI: false,
              });

              instance.resendChat();
            });
          }
        } else if (cta == "Share with") {
        }
        else if (cta == "Save"){
          alert('Comming soon!');
        }
        // Handle here
      } else {
        // Pass on.
        this.$emit("RaiseCta", cta, data, this.currentChat.Chat);
      }
    },
    sendMsg(evt) {
      if (!this.typedMessage) return;
      if (evt.shiftKey) {
        return;
      }

      this.currentChat.Chat.push({
        time: new Date(),
        isSent: true,
        role: "user",
        content: this.typedMessage,
        isSeen: true,
      });
      this.resendChat();
      this.typedMessage = "";
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value;
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isChatSidebarActive = value;
    },
    updateUserProfileId(userId) {
      this.userProfileId = userId;
      this.activeProfileSidebar = !this.activeProfileSidebar;
    },
    getUserStatus() {
      return "success";
    },
  },
  components: {
    AIChatLog,
    VuePerfectScrollbar,
    AIChatNavbar,
    FeatherIcon,
  },
  props: {
    context: {
      type: Object,
      required: false,
    },
    autoStart: {
      type: Boolean,
      required: false,
      default: true,
    },
    IsDefaultUserInterview: {
      type: Boolean,
      required: false,
      default: true,
    },
    ChatToLoad: {
      type: Array,
    },
    IsCollapsed: {
      type: Boolean,
      default: false,
    },
    IsMultiUserChat: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    ChatToLoad(newVal) {
      this.$set(this.currentChat, "Chat", newVal);
    },
  },
};
</script>
<style>
.tcv-workingAnalytics .router-header {
  display: none !important;
}
.tcv-workingAnalytics {
  height: 80%;
  overflow: hidden;
}

.chat-msg-textarea {
  resize: none !important;

  /* padding: 0px !important; */
}

.chat-msg-textarea.focusx {
  /* padding: 0px !important; */
}

.chat-wrapper {
  height: 100vh;
}

.chat__bg {
  height: 100%;
}

.chat-content-scroll-area {
  max-height: calc(100vh - 5em);
  min-height: calc(100vh - 5em);
  border: none !important;
  border: 1px solid #efefef;
}

.chat__input {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
}
</style>
